var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12039_13323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16C4.09 16 0.5 12.41 0.5 8C0.5 3.59 4.09 0 8.5 0C12.91 0 16.5 3.59 16.5 8C16.5 12.41 12.91 16 8.5 16ZM8.5 2C5.19 2 2.5 4.69 2.5 8C2.5 11.31 5.19 14 8.5 14C11.81 14 14.5 11.31 14.5 8C14.5 4.69 11.81 2 8.5 2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5025 17.9999C17.2425 17.9999 16.9925 17.8999 16.7925 17.7099L12.7925 13.7099C12.4025 13.3199 12.4025 12.6899 12.7925 12.2999C13.1825 11.9099 13.8125 11.9099 14.2025 12.2999L18.2025 16.2999C18.5925 16.6899 18.5925 17.3199 18.2025 17.7099C18.0025 17.9099 17.7525 17.9999 17.4925 17.9999H17.5025Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12039_13323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.777c6f4020a3eb1920782f3f2e87d9b8.svg";
export { ForwardRef as ReactComponent };